import {Component, Input, OnInit} from '@angular/core';
import {Question} from '../../models/underwriter.model';

@Component({
    selector: 'app-question-interstitial-variation-one',
    templateUrl: './question-interstitial-variation-one.component.html',
    styleUrls: ['./question-interstitial-variation-one.component.scss'],
    standalone: false
})
export class QuestionInterstitialVariationOneComponent implements OnInit {

  @Input() question: Question;
  constructor() { }

  ngOnInit(): void {
  }

}
